/**
 * Formats integer cents as EUR with German locale.
 *
 * @param {number} cents - Amount in minor units
 * @returns {string} Formatted amount
 */
export function formatEuroFromCents(cents) {
    const value = (Number(cents) || 0) / 100;
    return value.toLocaleString("de-DE", { style: "currency", currency: "EUR" });
}

/**
 * Maps API error codes to German admin copy.
 *
 * @param {Error & { body?: { error?: string } }} error - Failed fetch error
 * @returns {string} User-facing message
 */
export function mapPlatformMarginError(error) {
    const code = error?.body?.error;
    if (code === "INVALID_DATE_RANGE") {
        return "Ungültiger Zeitraum. Bitte Start- und Enddatum prüfen.";
    }
    if (code === "RANGE_TOO_LARGE") {
        return "Der gewählte Zeitraum ist zu lang (max. 120 Tage).";
    }
    return error?.message || "Daten konnten nicht geladen werden.";
}

/**
 * Builds a CSV download for the current customer rows.
 *
 * @param {Array<Object>} customers - API customer rows
 * @returns {string} Semicolon-separated CSV
 */
export function buildPlatformMarginCsv(customers) {
    const header =
        "balanceAccountId;customer;paymentCount;grossEur;merchantCreditEur;provisionBruttoEur;adyenAbzugFoodGeniusEur;reingewinnNettoEur;mapped";
    const lines = customers.map((row) =>
        [
            row.balanceAccountId,
            (row.customerLabel || "").replace(/;/g, ","),
            row.paymentCount,
            (row.grossCents / 100).toFixed(2).replace(".", ","),
            (row.merchantCreditCents / 100).toFixed(2).replace(".", ","),
            (row.provisionBruttoCents / 100).toFixed(2).replace(".", ","),
            (row.adyenAbzugFoodGeniusCents / 100).toFixed(2).replace(".", ","),
            (row.reingewinnNettoCents / 100).toFixed(2).replace(".", ","),
            row.mapped ? "ja" : "nein",
        ].join(";")
    );
    return [header, ...lines].join("\n");
}
